import React from 'react';
import ReactSpeedometer from "react-d3-speedometer";


function Speedometer() {


  return (

    <div>

        {/* <ReactSpeedometer
         value={333}
         needleHeightRatio={0.5}
         labelFontSize={'0px'}
        segments={5}  
        segmentColors={[
          "#EA3943",
          "#EB9305",
          "#65D331",
          "#16C784",
          "#67D32F",
        ]}
         width={180}
         height={80}
         ringWidth={40}             
        /> */}


        <ReactSpeedometer
        width={180}
        height={120}
        needleHeightRatio={0.4}
        value={777}
        currentValueText="Extreme Good"
        customSegmentLabels={[
          {
            text: 'Very Bad',
            position: 'INSIDE',
            color: '#555',
          },
          {
            text: 'Bad',
            position: 'INSIDE',
            color: '#555',
          },
          {
            // text: 'Ok',
            position: 'INSIDE',
            color: '#555',
            fontSize: '19px',
          },
          {
            text: 'Good',
            position: 'INSIDE',
            color: '#555',
          },
          {
            text: 'Very Good',
            position: 'INSIDE',
            color: '#555',
          },
        ]}
        ringWidth={20}
        needleTransitionDuration={3333}
        needleTransition="easeElastic"
        labelFontSize={'0px'}
        needleColor={'#90f2ff'}
        textColor={'#000'}
      />
             
    </div>

  )
}

export default Speedometer